'use strict';

angular.module('popovers', [])

.directive('hidePopover', ['$document', '$rootScope', function($document, $rootScope){
	function esconderTableHeaders(){
		var theads = document.getElementsByTagName('thead');
		for(var i=0; i < theads.length;i++)
		{
			theads[i].style.display = '';
		}
		var actions = $('.actionsHeader')[0]
		if(typeof actions !== "undefined"){
			actions.style.display = 'none';
		}
	}
	return{
		restrict: 'A',
		link: function(scope, elem, attr, ctrl){
			elem.bind('click', function(e){
				e.stopPropagation();
				esconderTableHeaders();
				scope.$apply(attr.deselect);
			});
			$document.bind('click', function(e){
				if(!$(e.target).hasClass('pika-select'))
				{
				    $('div.popover, div.popoverFilter, div.popoverFilter1').each(function (index, elem) {

				        var element = $(elem);

				        if (!element.hasClass('popover--hidden')) {
				            element.toggleClass('popover--hidden');
				            if (element.attr('popover-confirmacion')) {
				                $rootScope.$broadcast('mostrar-popover', { nombre: element.attr('popup-confirmacion'), mostrar: false });
						    }
						}
					});
				}
			});

			$document.bind('touchstart', function(){
			    $('div.popover').each(function (index, elem) {

			        var element = $(elem);

			        if (!element.hasClass('popover--hidden')) {
			            element.toggleClass('popover--hidden');
			            if (element.attr('popover-confirmacion')) {
			                $rootScope.$broadcast('mostrar-popover', { nombre: element.attr('popup-confirmacion'), mostrar: false });
					    }
					}
				});
				esconderTableHeaders();
				scope.$apply(attr.deselect);
			});
		}
	};
}])

.directive('hideOnClick', function(){
	return{
		restrict:'A',
		link:function(scope, elem, attr){
			elem.bind('click', function(e){
				if(!$(e.target).hasClass('pika-select'))
				{
					$('div.popover').each(function(index,elem){
						if(!$(elem).hasClass('popover--hidden')){
							$(elem).toggleClass('popover--hidden');
						}
					});
				}
			});

			elem.bind('touchstart', function(){
				$('div.popover').each(function(index,elem){
					if(!$(elem).hasClass('popover--hidden')){
						$(elem).toggleClass('popover--hidden');
					}
				});
			})
		}
	}
})

.directive('popItOver', function(){
	return {
      restrict: 'A',
      scope: {
        visible: "="
      },
		link: function(scope,elem,attr){
			elem.bind('click', function(){
				var popover = $(attr.popItOver);
              popover.toggleClass('popover--hidden');

        if (attr.visible) {
          scope.$watch(() => popover.hasClass('popover--hidden'), noVisible => scope.visible = !noVisible);
        }
   
				popover.bind('click', function(e){
					e.stopPropagation();
				});
				popover.bind('touchstart', function(e){
					e.stopPropagation();
				});
				$('div.popover').each(function(index,elems){
					if(!$(elems).hasClass('popover--hidden') && (popover[0] !== elems)){
						$(elems).toggleClass('popover--hidden');
					}
				});
			});
		}
	};
})

.directive('rowPopUp', function () {
	return {
		restrict: 'A',
		scope:false,
		link: function (scope, iElement, iAttrs) {
			var button = iElement;
			var popup = $(iAttrs.rowPopUp);
			//popup.css('position', 'fixed');

			function showPopup(e){
				$('div[class*="-popover"]').each(function(index,elems){
					if(!$(elems).hasClass('hidden') && (popup[0] !== elems)){
						$(elems).toggleClass('hidden');
					}
				});
				var popupTop = button.offset().top + button.innerHeight() + 12;
				var popupLeft = button.offset().left + (button.innerWidth()/2) - (popup.innerWidth()/2);
				popup.css('top', popupTop+'px');
				popup.css('left', popupLeft+'px');
				if(popup.hasClass('hidden')){
					popup.toggleClass('hidden');
				}
				popup.bind('click', function(e){
					e.stopPropagation();
				});
				popup.bind('touchstart', function(e){
					e.stopPropagation();
				});
			}

			button.bind('click', showPopup);
		}
	};
})
.directive('cancelConfirm', function () {
  return {
    restrict: 'A',
    scope:false,
    link: function (scope, iElement, iAttrs) {
      var button = $(iElement);
      var popup = $(iAttrs.cancelConfirm);
      //popup.css('position', 'fixed');

      function showPopup(e){
        $('div[class*="-popover"]').each(function(index,elems){
          if(!$(elems).hasClass('hidden') && (popup[0] !== elems)){
            $(elems).toggleClass('hidden');
          }
        });
        var popupPosition = $('.listTableRow--selected .icon--circleCross');
        var popupTop = popupPosition.offset().top + popupPosition.innerHeight() + 12;
        var popupLeft = popupPosition.offset().left + (popupPosition.innerWidth()/2) - (popup.innerWidth()/2);
        popup.css('top', popupTop+'px');
        popup.css('left', popupLeft+'px');
        if(popup.hasClass('hidden')){
          popup.toggleClass('hidden');
        }
        popup.bind('click', function(e){
          e.stopPropagation();
        });
        popup.bind('touchstart', function(e){
          e.stopPropagation();
        });
      }

      button.bind('click', showPopup);
    }
  };
})
.directive('propagationOff', function(){
	return{
		restrict: 'A',
		link: function(scope,elem,attr){
			if(attr.propagationOff)
			{
				elem.bind(attr.propagationOff, function(e){
					e.stopPropagation();
				});
			}
			else
			{
				elem.bind('click', function (e) {

					e.stopPropagation();
				});
				elem.bind('touchstart', function(e){
					e.stopPropagation();
				});
			}
		}
	};
})

.directive('customPopover', function(){
	return{
		restrict:'A',
		link: function(scope,elem,attr){
			var trigger = (attr.popoverOn) ? attr.popoverOn:'click';
			elem.bind(trigger, function(){
				
				var popover = $(attr.customPopover);
				if(attr.popoverData)
				{
					popover.append('<span>'+attr.popoverData+'</span>');
				}
				var topValue = elem.offset().top + elem.outerHeight(true) + 5;
				var leftValue = elem.offset().left + (elem.outerWidth(true)/2) - (popover.outerWidth(true)/2)
				popover.css('top', topValue+'px');
				popover.css('top', leftValue+'px');
				popover.css('position', 'fixed');
				popover.toggleClass('popover--hidden');
				popover.bind('click', function(e){
					e.stopPropagation();
				});
				popover.bind('touchstart', function(e){
					e.stopPropagation();
				});
				$('div.popover').each(function(index,elems){
					if(!$(elems).hasClass('popover--hidden') && (popover[0] !== elems)){
						$(elems).toggleClass('popover--hidden');
					}
				});
			});
		}
	}
})

.directive('displayOnFocus', function(){
	// Runs during compile
	return {
		restrict: 'A',
		require: ['uibTypeahead','ngModel'],
		link: function($scope, iElm, iAttrs, ctrls) {
            iElm.bind('focus', function () {
                try {
                    ctrls[0].init(ctrls[1].$viewValue || '');
                } catch (e) {}              
				$scope.$apply();
			});
		}
	};
})

.directive('customSelect', function(){
	return{
		restrict: 'A',
		link: function(scope,elem,attr){
			var select = $(attr.customSelect);
			elem.bind('click', function(){
				var topValue = -5;
				if(scope.selectedOpt > 0)
				{
					topValue = (scope.selectedOpt * -33);
				}
				select.css('top', topValue);
				select.toggleClass('popover--hidden');
				$('li :nth-child('+(scope.selectedOpt+1)+')').toggleClass('popoverFilterElement--active');
				$('div.popover').each(function(index,elems){
					if(!$(elems).hasClass('popover--hidden') && (select[0] !== elems)){
						$(elems).toggleClass('popover--hidden');
					}
				});
			});
			select.bind('click', function(e){
				
				e.stopPropagation();
				if(!select.hasClass('popover--hidden'))
					select.toggleClass('popover--hidden');
			});

			select.bind('touchstart', function(e){
				
				e.stopPropagation();
			});

			select.bind('mouseover', function(e){
				var option = $('li :nth-child('+(scope.selectedOpt+1)+')');
				if(option.hasClass('popoverFilterElement--active')){
					option.toggleClass('popoverFilterElement--active');
				}
			});
		}
	};
})
.directive('popupConfirmacion', ['$document', function ($document) {

    var claseOcultar = 'popover--hidden';

    return {
        restrict: 'A',
        template: require('../../../../app/views/Templates/Directivas/popupConfirmacion.html'),
        scope: {
            mensaje: "@",
            nombre: "@popupConfirmacion",
            accion: "&popupAccion",
            grupo: "@popupGrupo",
            mensajeConfirmar: '@',
            mensajeCancelar: '@',
            mostrarCancelar: '@'
        },
        replace: true,
        link: function (scope, elem, attrs) {

            if (!scope.mensaje) throw Error("popup-confirmacion requiere de un mensaje");

            scope.$on('mostrar-popover', function (evento, opciones) {
                if (scope.nombre === opciones.nombre) {
                    if (opciones.mostrar) {
                        elem.removeClass(claseOcultar);
                    } else {
                        elem.addClass(claseOcultar);
                    }
                }

                if (scope.grupo && opciones.grupo && scope.grupo === opciones.grupo) {
                    if (scope.nombre !== opciones.nombre) {
                        if (opciones.mostrar) {
                            elem.addClass(claseOcultar);
                        } else {
                            elem.removeClass(claseOcultar);
                        }
                    }
                }

            });

            if (angular.isString(attrs['popupArrow'])) {
                elem.find('.popover__arrow').addClass(attrs['popupArrow']);
            }

            scope.mostrarPopup = function (valor) {
                if (valor) {
                    elem.removeClass(claseOcultar);
                } else {
                    elem.addClass(claseOcultar);
                }
            };

            scope.confirmar = function () {
                scope.accion();
                scope.mostrarPopup(false);
            };

            scope.cancelar = function () {
                scope.hidePopup(false);
            };

        }
    };

}]);
